import script from "./PharmacyInvoice.vue?vue&type=script&setup=true&lang=js"
export * from "./PharmacyInvoice.vue?vue&type=script&setup=true&lang=js"

import "./PharmacyInvoice.vue?vue&type=style&index=0&id=6da3e3c5&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6da3e3c5"]])

export default __exports__